import { render, staticRenderFns } from "./page-aboutus-two.vue?vue&type=template&id=9eab7e66"
import script from "./page-aboutus-two.vue?vue&type=script&lang=js"
export * from "./page-aboutus-two.vue?vue&type=script&lang=js"
import style0 from "./page-aboutus-two.vue?vue&type=style&index=0&id=9eab7e66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports